import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';
import { Controller, UseFormRegisterReturn, Control } from 'react-hook-form';

const animatedComponents = makeAnimated();

type Option = {
  label: React.ReactNode;
  value: string | number;
};

type InputFieldProps = FieldWrapperPassThroughProps & {
  options: Option[];
  registration: Partial<UseFormRegisterReturn>;
  control: Control<any>;
  value?: any;
  menuIsOpen?: boolean;
  loading?: boolean;
  defaultValue?: any;
  emitChange?: (val: any) => void;
};

export const MultiSelect = (props: InputFieldProps) => {
  const {
    registration,
    error,
    options,
    label,
    control,
    value,
    menuIsOpen,
    loading,
    defaultValue,
    emitChange,
  } = props;
  const { name } = registration;

  return (
    <FieldWrapper error={error} label={label}>
      <Controller
        name={name ?? ''}
        control={control}
        defaultValue={value}
        render={({ field: { value, onChange } }) => (
          <Select<Option, true>
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                lineHeight: 2,
                borderColor: error?.message ? 'red' : '#dee2e6',
                borderRadius: '0.375rem',
                zIndex: '4 !important',
              }),
            }}
            closeMenuOnSelect={false}
            components={animatedComponents}
            value={defaultValue}
            onChange={(newVal) => {
              const values = newVal.map((i) => i.value);
              onChange(values);
              emitChange && emitChange(newVal);
            }}
            defaultValue={options.filter((i) => value?.includes(i.value))}
            isMulti
            placeholder={label}
            options={options}
            menuIsOpen={menuIsOpen}
            isLoading={loading}
          />
        )}
      />
    </FieldWrapper>
  );
};
